export const isRunningImmobilizer = (imbStatus) => {
    if (imbStatus !== undefined && imbStatus === 'executing') {
        return true;
    }
    return false;
};

export default {
    isRunningImmobilizer
};